import { type DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

export const getBodyItemInDocument = (
  doc: DocumentItem,
): DocumentItem | undefined =>
  doc.children?.find((child) => child?.type === 'Body');
